module.exports = __webpack_public_path__ + "static/img/edit-icon.b5b7625b.svg";